export enum WEBSITE {
  EDGEPOINT = 'Edgepoint',
  CYMBRIA = 'Cymbria',
}
